import { Injectable } from '@angular/core';

import { LogicControlDeviceBehaviorPlugin } from '@shure/device-ui/settings/logic-control/data-access';
import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';
import { LightsSettingsSupportType } from '@shure/shared/angular/features/device-lights-settings/data-access';

import { DefaultCdmDeviceBehaviorPlugin } from './default-cdm.device-behavior';

@Injectable()
export class Mxa310CdmDeviceBehaviorPlugin
	extends DefaultCdmDeviceBehaviorPlugin
	implements LogicControlDeviceBehaviorPlugin
{
	public override readonly models: DeviceModel[] = [DeviceModel.MXA310];

	public override getLightsSettingsSupportType(): LightsSettingsSupportType {
		return LightsSettingsSupportType.SupportedLegacy;
	}

	public isLightsNextSupported(): boolean {
		return false;
	}
}
